import 'globals';
import highlightText from '@brianmcallister/highlight-text';

(function (window, document, PageLoadedQueue) {
    function highlightMediaTitles(container, searchValue) {
        if (!searchValue) {
            return;
        }

        const searchValues = searchValue.split(/[.,;\/ -]/);
        container.querySelectorAll('.mediathek-item-title').forEach(function (mediaItem) {
            mediaItem.innerHTML = highlightText(mediaItem.textContent, searchValues);
        });
    }

    function buildMediaSearchUri(container) {
        const searchTerm = container.dataset.searchTerm;
        const sites = container.dataset.sites;
        const baseUri = window._AVENCY_BASE_actions && window._AVENCY_BASE_actions.mediaSearchResult;

        if (!searchTerm || !baseUri) {
            return '';
        }

        const url = new URL(baseUri, window.location.origin);
        url.searchParams.set('search', searchTerm);

        if (sites) {
            url.searchParams.set('sites', sites);
        }

        return url.toString();
    }

    function showMediaSearchError(container) {
        container.classList.add('is-error');

        const contentContainer = container.querySelector('.media-search-lazy-content');
        if (contentContainer) {
            contentContainer.style.display = 'none';
        }

        let errorEl = container.querySelector('.media-search-error');
        if (!errorEl) {
            errorEl = document.createElement('div');
            errorEl.className = 'media-search-error';
            container.appendChild(errorEl);
        }
        errorEl.textContent = container.dataset.errorMessage || '';
    }

    function loadMediaSearchResults(container) {
        if (container.dataset.loaded === 'true' || container.dataset.loading === 'true') {
            return;
        }

        const contentContainer = container.querySelector('.media-search-lazy-content');
        const uri = buildMediaSearchUri(container);

        if (!contentContainer || !uri) {
            return;
        }

        container.dataset.loading = 'true';
        container.classList.remove('is-error');

        const request = new XMLHttpRequest();
        request.open('GET', uri, true);
        request.onload = function () {
            container.dataset.loading = 'false';

            if (this.status >= 200 && this.status < 400 && this.response !== '') {
                contentContainer.innerHTML = this.response;
                container.classList.add('is-loaded');
                container.dataset.loaded = 'true';
                highlightMediaTitles(container, container.dataset.searchTerm);

                if (window.lazyLoadObject instanceof window.LazyLoad) {
                    window.lazyLoadObject.update();
                }
                return;
            }

            showMediaSearchError(container);
        };
        request.onerror = function () {
            container.dataset.loading = 'false';
            showMediaSearchError(container);
        };
        request.send();
    }

    function initMediaSearchLazyLoad(searchPlugin) {
        const containers = searchPlugin.querySelectorAll('.media-search-lazy');
        if (!containers.length) {
            return;
        }

        function loadAll() {
            containers.forEach(loadMediaSearchResults);
        }

        const mediaTabPane = searchPlugin.querySelector('#pills-media');
        if (mediaTabPane && mediaTabPane.classList.contains('active') && mediaTabPane.classList.contains('show')) {
            loadAll();
        }

        const tabList = searchPlugin.querySelector('#pills-tab');
        if (tabList) {
            window.jQuery(tabList).on('shown.bs.tab', function (event) {
                if (event.target.getAttribute('href') === '#pills-media') {
                    loadAll();
                }
            });
        }
    }

    function highlightContentResults(searchPlugin, searchValue) {
        const searchValues = searchValue.split(/[.,;\/ -]/);

        searchPlugin.querySelectorAll('.search-item').forEach(function (item) {
            const title = item.querySelector('a:first-child');
            const text = item.querySelector('p:nth-child(2)');

            if (title) {
                title.innerHTML = highlightText(title.textContent, searchValues);
            }
            if (text) {
                text.innerHTML = highlightText(text.textContent, searchValues);
            }
        });
    }

    PageLoadedQueue.addFunction(function () {
        const searchPlugin = document.querySelector('.flowpack-searchplugin-search');
        if (!searchPlugin) {
            return;
        }

        const searchInput = searchPlugin.querySelector('input[name=search]');
        if (searchInput && searchInput.value) {
            highlightContentResults(searchPlugin, searchInput.value);
        }

        initMediaSearchLazyLoad(searchPlugin);
    });
})(window, document, window.PageLoadedQueue);
